import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './manage-my-rlink-categories.component'

let module = angular.module('manageMyRlinkCategories', [
  uiRouter
])

.component('manageMyRlinkCategories', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/categories/index.js